import React from 'react'

import EnumDropdown, { getValueFunc } from '../../../../organisms/enum-dropdown/EnumDropdown'

interface Props {
  onChange: (selected: { value: string, label: string}) => void
  value?: string
  error?: string
  label?: string
  name?: string
}

export const options = [
  {
    value: 'australia',
    label: 'Australia'
  },
  {
    value: 'new_zealand',
    label: 'New Zealand'
  },
  {
    value: 'usa',
    label: 'USA'
  },
  {
    value: 'united_kingdom',
    label: 'United Kingdom'
  },
  {
    value: 'europe',
    label: 'Europe'
  },
  {
    value: 'indonesia',
    label: 'Indonesia'
  },
  {
    value: 'japan',
    label: 'Japan'
  },
  {
    value: 'china',
    label: 'China'
  },
  {
    value: 'singapore',
    label: 'Singapore'
  },
  {
    value: 'small_market',
    label: 'Small Market'
  },
  {
    value: 'medium_market',
    label: 'Medium Market'
  },
  {
    value: 'big_market',
    label: 'Big Market'
  }
]

export const getLabelFromValue = getValueFunc(options)

function CountryDropdown({
  onChange,
  value,
  error,
  label,
  name,
}: Props) {
  return (
    <EnumDropdown
      onChange={onChange}
      options={options}
      value={value}
      error={error}
      label={label}
      name={name ?? 'country-dropdown'}
    />
  )
}


export default CountryDropdown
